import { render, staticRenderFns } from "./PositionSettingsModal.vue?vue&type=template&id=4e3d0944&scoped=true&"
import script from "./PositionSettingsModal.vue?vue&type=script&lang=js&"
export * from "./PositionSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3d0944",
  null
  
)

export default component.exports